import { useCallback, useEffect, useRef, useState } from "react";
import Button from '@mui/material/Button';
import { Container, Divider, FormControl, FormControlLabel, MenuItem, Radio, RadioGroup, Stack, Tab, Tabs, TextField, Tooltip, Typography } from "@mui/material";
import TimezoneSelect from "react-timezone-select";
import { useNavigate, useParams } from "react-router-dom";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import Select from 'react-select';
import FormPageHeader from "../utilities/FormPageHeader";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import customStyles from "app/shared-components/SelectCustomStyle";

const RegionForm = () => {

    const formRef = useRef(null);
    const { id } = useParams();
    const navigate = useNavigate();
    const [tabValue, setTabValue] = useState(0);
    const [error, setError] = useState();
    const [validError, setValidError] = useState({});
    const [checksubmit, setCheckSubmit] = useState(false);
    const [regionName, setRegionName] = useState("")
    const [users, setUsers] = useState([]);
    const [tempManager, setTempManager] = useState([])
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [editData, setEditData] = useState();
    const [hideDelete, setHideDelete] = useState(true)
    const [saveDisable, setSaveDisable] = useState(true)

    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.region}`;

    const handleSubmit = async () => {
        setCheckSubmit(true);
        const model = {
            id: regionName,
            managers: tempManager,
        };

        try {
            if (id) {
                if (regionName && !validError.regionName && tempManager && !validError.tempManager) {
                    await OAuthService.updateData(url, id, model);
                    setSuccessMsg("Data Updated Successfully")
                    setSnackState(true);
                    setTimeout(() => { navigate('/regions') }, 800);
                }
            } else {
                if (regionName && !validError.regionName && tempManager && !validError.tempManager) {
                    await OAuthService.addData(url, model);
                    setSuccessMsg("Data saved Successfully")
                    setSnackState(true);
                    setTimeout(() => { navigate('/regions') }, 800);
                }
            }

        } catch (error) {
            setError(error.message)
            return;
        }

    }
    const getRegion = async () => {
        try {
            const result = await OAuthService.getEditData(url, id);
            const region = result?.data;
            setRegionName(region.id)
            setTempManager(region.managers)
            setEditData(region)
        } catch (error) {
            console.log('error', error);
            setError(error.message)
        }
    }

    const findUsers = async () => {
        const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}`;
        try {
            const list = await OAuthService.getList(url + `?sort=userId,desc&size=1000`);
            let users = list.data?._embedded?.users;
            users = users.map((user) => {
                const lastName = user?.lastName ? user.lastName : '';
                const middleName = user?.middleName ? user.middleName : '';
                const firstName = user?.firstName ? user.firstName : '';
                const name = firstName + ' ' + middleName + ' ' + lastName + ' (' + user.userName + ')';

                return {
                    label: name,
                    value: user.email
                }
            })
            setUsers(users);
        } catch (error) {
            setError(error.message);
        }
    }

    const handleUserChange = (value) => {
        const user = value.map((row) => {
            return row.value
        });
        setTempManager(user);
    };

    useEffect(() => {
        if (id) {
            getRegion();
            setHideDelete(false)
        }
    }, [])

    useEffect(() => {
        findUsers();
    }, [])


    function handleTabChange(event, value) {
        setTabValue(value);
    }

    const handleDelete = async () => {
        try {
            if (id) {
                await OAuthService.deleteData(url, id);
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
                setTimeout(() => { navigate('/regions') }, 800);
            }

        } catch (error) {
            setError(error.message);
            return;
        }
    }

    const handleCancel = () => {
        navigate('/regions')
    }

    useEffect(() => {
        if (regionName) {
            if (editData) {
                if (regionName !== editData.id || JSON.stringify(tempManager) !== JSON.stringify(editData.managers)) {
                    setSaveDisable(false);
                } else {
                    setSaveDisable(true);
                }
            } else {
                setSaveDisable(false);
            }
        } else {
            setSaveDisable(true);
        }
    }, [regionName, tempManager]);

    return (
        <div className="w-full h-full overflow-scroll">
            <FormPageHeader
                componentName="Region"
                handleDelete={handleDelete}
                handleSubmit={handleSubmit}
                breadCrumbSeperator=">"
                currentPage={id ? "Update Region" : "Add Region"}
                parentBreadcrumbData={[{ pageName: 'Region List', pageLink: '/regions' }]}
                error={error}
                successMsg={successMsg}
                snackState={snackState}
                hideDelete={hideDelete}
                handleCancel={handleCancel}
                saveDisable={saveDisable}
            />
            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                indicatorColor="secondary"
                textColor="inherit"
                sx={{ color: 'yellow' }}
                variant="scrollable"
                scrollButtons="auto"
                classes={{ root: 'w-full h-64 border-b-1' }}
            >
                <Tab className="h-64" label="General" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
            </Tabs>
            <div className="p-16 sm:p-24 max-w-3xl">
                <FormControl
                    ref={formRef}
                    className="flex flex-col justify-center"
                >
                    <div className={tabValue !== 0 ? 'hidden' : ''}>
                        <Stack>
                            <label>*Region Name</label>
                            <TextField
                                className="mb-16"
                                type="text"
                                name="regionName"
                                value={regionName}
                                error={(checksubmit && !regionName) || validError.regionName ? true : false}
                                helperText={(checksubmit && !regionName) ? "This field is required" : validError.regionName}
                                onChange={(e) => setRegionName(e.target.value.toUpperCase())}
                                required
                                variant="outlined"
                                disabled={id ? true : false}
                                sx={id ? { 
                                  backgroundColor: 'action.disabledBackground',
                                  "& .MuiInputBase-input.Mui-disabled": {
                                    WebkitTextFillColor: (theme) => theme.palette.text.primary,
                                  }
                                } : {}}
                            />
                        </Stack>

                        <Stack>
                            <label>Manager </label>
                            <Select
                                className="basic-multi-select mb-4"
                                name="manager"
                                required
                                value={users.filter(obj => tempManager?.includes(obj.value))}
                                // error={(checksubmit && !tempManager) || validError.tempManager ? true : false}
                                // helperText={(checksubmit && !tempManager) ? "This field is required" : validError.tempManager}
                                onChange={handleUserChange}
                                isMulti
                                options={users}
                                styles={customStyles()}
                            />
                            {/* <Typography mt={0} className="text-[#f44336] text-sm ml-14">{(checksubmit && !tempManager?.length > 0) ? "This field is required" : validError?.tempManager}</Typography> */}
                        </Stack>
                    </div>
                </FormControl>
            </div>

        </div >
    )
}

export default RegionForm;
